module.exports = __webpack_public_path__ + "static/media/step1.20693a11.png";